export { AppFooterComponent } from './app-footer.component';
export { AppFooterModule } from './app-footer.module';
